import { MouseEvent, useCallback } from "react";
import { useClipboard } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { useCustomActivityMutation } from "src/api/client/custom-activity.api";
import { useWfToast, EnumToastStatus } from "src/hooks/use-wf-toast";

interface IUseCopyIsinOptions {
    isin: string;
    onCopySuccess?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const useCopyIsin = ({ isin, onCopySuccess }: IUseCopyIsinOptions) => {
    const { t } = useTranslation("common");
    const { onCopy } = useClipboard(isin);
    const toast = useWfToast();
    const createCustomActivity = useCustomActivityMutation();

    const copyIsin = useCallback(
        (event: MouseEvent<HTMLButtonElement>) => {
            onCopy();
            toast({ status: EnumToastStatus.Info, title: t("copy-isin-success") });
            onCopySuccess?.(event);
            createCustomActivity({ activity: "CopiedIsin", value: isin });
        },
        [onCopy, toast, t, onCopySuccess, createCustomActivity, isin]
    );

    return {
        copyIsin,
    };
};
